import { CLI_REGISTRY, type CliInstallInfo } from "@/lib/cli-install-commands";
import type { CliChoice } from "@/components/onboarding/cli-chooser-phases";
import type { AvailableRuntime } from "@/stores/companion-store";

export const INSTALL_CHOICES = [
  CLI_REGISTRY.claude,
  CLI_REGISTRY.codex,
  CLI_REGISTRY.opencode,
] as const satisfies readonly CliInstallInfo[];

export function cliToRuntimeType(cliId: CliChoice): AvailableRuntime["type"] {
  if (cliId === "claude") return "claude_cli";
  if (cliId === "codex") return "codex_cli";
  return "opencode_cli";
}

export function runtimeTypeToCli(
  runtimeType: AvailableRuntime["type"],
): CliChoice {
  if (runtimeType === "claude_cli") return "claude";
  if (runtimeType === "codex_cli") return "codex";
  return "opencode";
}
